var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69.3 70.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "inherit"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M4.4 48.9h10.1v20.2H4.4zm15.8-7.5h10.1v27.8H20.2zm15.4 4.7h10.1v23H35.6zM51.4 30h10.1v39.1H51.4zM1.5 69.2h66.3M5.6 34.5l15.1-10.1 16.6 8 14.4-18.8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.1,
    cy: 9.4,
    r: 7.9,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    strokeMiterlimit: 10,
    d: "M57.2 11.3c.2-.3.4-.8.6-.6.3.2.7.4 1.1.6V9.6c-.8-.3-1.8-.8-1.8-2 0-1 .8-1.7 1.7-1.7h.1v-.4c0-.1.1-.2.2-.2h.1c.1 0 .2.1.2.2v.3c.6.1 1.1.3 1.6.6q.15.15 0 .3c-.2.3-.4.8-.7.6s-.7-.4-1-.5v1.6c.8.3 1.9.9 1.9 2.1 0 1-.8 1.8-1.8 1.8h-.1v.9c0 .1-.1.2-.2.2s-.3 0-.3-.2v-.9c-.6 0-1.2-.3-1.7-.7 0-.1 0-.2.1-.3zm1.7-4.5c-.5 0-.7.3-.7.6s.2.6.7.9zm1.2 3.8c0-.4-.2-.6-.7-.9v1.6c.4 0 .7-.3.7-.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.040bfeb6ca384cf7aff14e0a329a6e92.svg";
export { ForwardRef as ReactComponent };